import React from "react";
import {PageHero} from "../common/PageHero";

export const Contact = () => {
    return (
        <>
            <PageHero title={'Contact'}
                      badge={'Kom langs'}
                      lead={'Recreatiedomein Fort van Merksem — je vindt ons op de eerste verdieping.'}/>
            <div className={'ttc-section ttc-split'}>
                <article className={'ttc-card'}>
                    <p className={'ttc-eyebrow'}>Adres</p>
                    <h3 className={'ttc-card-title'}>Recreatiedomein Fort van Merksem</h3>
                    <p className={'ttc-card-body'}>Fortsteenweg 120, 2170 Merksem</p>
                    <p className={'ttc-card-body'}>Auto’s kunnen worden geparkeerd buiten het fort op de daarvoor
                        voorziene parking. Ingang lokaal aan kant van petanquevelden. Lokaal bevindt zich op eerste
                        verdieping (geen lift).</p>
                    <div className={'ttc-embed mt-3'} style={{height: 280}}>
                        <iframe title={'google maps'} style={{border: 'none'}}
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9986.189119308796!2d4.4566028!3d51.2642444!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c409fc125902cd%3A0xd0ce71c43dff7b5a!2sTTC%20Bart%20Merksem!5e0!3m2!1snl!2sbe!4v1693468508128!5m2!1snl!2sbe"
                                loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>
                    </div>
                </article>
                <article className={'ttc-card featured'}>
                    <p className={'ttc-eyebrow'}>Meer info nodig?</p>
                    <h3 className={'ttc-card-title'}>Stuur ons een mail</h3>
                    <p className={'ttc-card-body'}>Voor algemene info kunt u ons mailen op{' '}
                        <a href="mailto:ttcbartmerksembestuur@gmail.com">ttcbartmerksembestuur ( @gmail.com )</a>.</p>
                    <a className={'ttc-btn'} href={'mailto:ttcbartmerksembestuur@gmail.com'}>Mail het bestuur</a>
                </article>
            </div>
        </>
    )
}
